import type { Observable } from 'rxjs';
import { distinct, mergeMap, shareReplay } from 'rxjs';

import { getHotelKey } from '@apps/main/modules/helpers/formatting';
import type { Dictionary } from '@apps/main/modules/helpers/rx';
import { logged, toDictionary } from '@apps/main/modules/helpers/rx';

import type {
  DestinationStaticInfo,
  HotelIngredientAdapter,
} from '@libs/trip-planner-interfaces';
import { StaticInfoType } from '@libs/trip-planner-interfaces';

import { searchHotels } from '../helpers/search';
import { createStaticInfo } from '../helpers/createStaticInfo';

export class DestinationStaticInfoSearchService {
  public search(
    ingredient: HotelIngredientAdapter
  ): Observable<Dictionary<DestinationStaticInfo>> {
    const destinationStaticInfo: Observable<DestinationStaticInfo> =
      searchHotels(ingredient.constraint, StaticInfoType.Destination).pipe(
        mergeMap(({ response: getHotelsResponse, type }) =>
          getHotelsResponse.hotels.map((hotel) =>
            createStaticInfo(
              hotel,
              getHotelsResponse,
              ingredient.ingredientId,
              type
            )
          )
        ),
        shareReplay()
      );

    return destinationStaticInfo.pipe(
      distinct((staticInfo) =>
        getHotelKey(staticInfo.hotelCode, staticInfo.ingredientId)
      ),
      toDictionary((staticInfo) =>
        getHotelKey(staticInfo.hotelCode, staticInfo.ingredientId)
      ),
      logged('destination static info'),
      shareReplay()
    );
  }
}
